import { Grid } from '@mantine/core';
import Image from 'next/image';
import Link from 'next/link';
import type { ReactNode } from 'react';

import { isProd } from '../../common/util/environmentConfig';
import dteLogo from '../../images/dteLogo.svg';
import styles from './Header.module.scss';
import { MenuButton } from './menu/MenuButton';
import { SearchBar } from './search/SearchBar';

export default function Header(): ReactNode {
	const classNames = [styles['main']];
	if (!isProd) {
		classNames.push(styles['nonProd']);
	}

	return (
		<header className={classNames.join(' ')}>
			<Grid align="center" gap={'xs'}>
				<Grid.Col span={'content'}>
					<MenuButton />
				</Grid.Col>
				<Grid.Col span={'content'}>
					<Link href="/" className={styles['logo']} prefetch={false}>
						<Image priority={true} src={dteLogo} alt="DTE" />
					</Link>
				</Grid.Col>
				<Grid.Col span={'content'}>
					<h1>Outage</h1>
				</Grid.Col>
				<Grid.Col span={{ base: 12, sm: 'auto' }}>
					<SearchBar />
				</Grid.Col>
			</Grid>
		</header>
	);
}
